import { TicketingFormCategory } from "@simplyk/common";

import { RateSettingIntents, RateSuggestionType } from "./detectRateSettingIntents";

export interface VisibleSuggestionTypesInput {
  intents: RateSettingIntents;
  formCategory: TicketingFormCategory;
  amount: number | null | undefined;
  isPayWhatYouCan: boolean;
  isGroup: boolean;
  isGeneratingReceipt: boolean;
  isMemberOnly: boolean;
  hasExistingPayments: boolean;
  canGenerateReceipt: boolean;
  canEnableMemberOnly: boolean;
  isRegistration: boolean;
  dismissed: ReadonlySet<RateSuggestionType>;
}

const PRIORITY: readonly RateSuggestionType[] = ["group", "taxReceipt", "memberOnly"];

export const getVisibleSuggestionTypes = ({
  intents,
  formCategory,
  amount,
  isPayWhatYouCan,
  isGroup,
  isGeneratingReceipt,
  isMemberOnly,
  hasExistingPayments,
  canGenerateReceipt,
  canEnableMemberOnly,
  isRegistration,
  dismissed,
}: VisibleSuggestionTypesInput): RateSuggestionType[] => {
  const isEvent = formCategory === TicketingFormCategory.Event;
  const isPriced = typeof amount === "number" || isPayWhatYouCan;
  if (!isEvent || !isPriced || hasExistingPayments) {
    return [];
  }

  const isEnabled: Record<RateSuggestionType, boolean> = {
    group: isGroup,
    taxReceipt: isGeneratingReceipt,
    memberOnly: isMemberOnly,
  };

  const canIssueReceipt = canGenerateReceipt && !isPayWhatYouCan && typeof amount === "number" && amount > 0;
  const isAvailable: Record<RateSuggestionType, boolean> = {
    group: !isRegistration,
    taxReceipt: canIssueReceipt,
    memberOnly: canEnableMemberOnly,
  };

  return PRIORITY.filter(
    (type) => Boolean(intents[type]) && !isEnabled[type] && !dismissed.has(type) && isAvailable[type]
  );
};
